import React from "react";
import "../assets/css/header.css";
import {AppStore, setLoginPage, useUser} from "../useAppPullState";
import {firebaseService} from "../service/firebase";

export default () => {
  const [authUser, setAuthUser] = useUser();
  return (
    <nav className='navbar fixed-top navbar-light main-header' style={{ height: 100 }}>
      <div className='container' style={{ justifyContent: "space-between" }}>

        <a className='navbar-brand links'>
          {/* <a className='header-link'>General</a> */}
          {authUser == null && (
            <a className='header-link' style={{
                cursor: "pointer"
            }} onClick={() => setLoginPage(true)}>
              Kirjaudu sisään
            </a>
          )}
          {authUser != null && (
            <a className='header-link' style={{
                cursor: "pointer"
            }} onClick={() => {
                firebaseService.signOut();
            }}>
              Kirjaudu ulos
            </a>
          )}
        </a>
      </div>
    </nav>
  );
};
